import { Tooltip, useDrawer } from '@iveco-ti/iveco-ds'
import { FileSearch } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { GenericContentModel } from '@/common/models/genericContent'
import { useSelectedGenericContentStore } from '../stores/useSelectedGenericContentStore'

type GenericContentInactiveActionsProps = {
  genericContent: GenericContentModel
}

export function GenericContentInactiveActions({
  genericContent,
}: GenericContentInactiveActionsProps) {
  const { t } = useTranslation(['common', 'registers'])
  const { setGenericContent } = useSelectedGenericContentStore()

  const drawerViewGenericContent = useDrawer('drawer-view-generic-content')

  const handleOpenView = () => {
    setGenericContent(genericContent)
    drawerViewGenericContent.open()
  }

  return (
    <div className="flex flex-row gap-2 items-center justify-center">
      <Tooltip text={t('common:components.table_row.view')}>
        <button
          type="button"
          className="p-1 hover:bg-base-100 rounded"
          onClick={handleOpenView}
        >
          <FileSearch size={18} className="text-brand-700" />
        </button>
      </Tooltip>
    </div>
  )
}
